import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaArrowLeft } from 'react-icons/fa';
import '../styles/404.css';

export default function NotFound() {
    return (
        <div className="not-found-page">
            <div className="not-found-content">
                <div className="not-found-number">404</div>
                <h1>Page Not Found</h1>
                <p>The page you're looking for doesn't exist or has been moved.</p>
                <div className="not-found-actions">
                    <Link to="/" className="home-btn">
                        <FaHome /> Go Home
                    </Link>
                    <button onClick={() => window.history.back()} className="back-btn">
                        <FaArrowLeft /> Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}